import { render, staticRenderFns } from "./BookAssingmentItem.vue?vue&type=template&id=6c829b94&scoped=true&"
import script from "./BookAssingmentItem.vue?vue&type=script&lang=js&"
export * from "./BookAssingmentItem.vue?vue&type=script&lang=js&"
import style0 from "./BookAssingmentItem.vue?vue&type=style&index=0&id=6c829b94&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c829b94",
  null
  
)

export default component.exports